import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { FullScreenLoader } from "../../components/ui/loaders/full-screen-loader.jsx";
import { tenantExists } from "../../services/api.service.js";
import { recordErrorInSentry } from "../../utils/init-sentry.js";
import { useAuth } from "../auth/use-auth.js";
import { CreateTenant } from "./create-tenant.jsx";
import { FailedToCheckTenant } from "./failed-to-check-tenant.jsx";
import { TenantContext } from "./tenant.context.js";

export const TenantExistsGuard = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { user } = useAuth();
  const { data, isLoading, error } = useQuery({
    queryFn: tenantExists,
    queryKey: ["tenantExists"],
  });
  const tenantContextValue = useMemo(
    () => (data?.exists ? { tenant: data } : null),
    [data]
  );

  if (isLoading) {
    return <FullScreenLoader message="Verifying your account..." />;
  }

  if (error) {
    recordErrorInSentry(error);
    return <FailedToCheckTenant />;
  }

  if (!tenantContextValue) {
    return <CreateTenant tenantId={user.tenantId} />;
  }

  return (
    <TenantContext.Provider value={tenantContextValue}>
      {children}
    </TenantContext.Provider>
  );
};
